import React from 'react'
import {SocialButtonsContainer, SocialLoginView, SocialLoginTitle} from './styled'
import SocialButton from './button'
import {ELEMENTS_IDS} from 'const'
import {getConfigValue} from 'theme'

const {swissIdLogin, facebookLogin, googleLogin, appleLogin} = ELEMENTS_IDS.logisterPage

const CircularSocialLogin = ({
  loginWithSwissID,
  loginWithFacebook,
  loginWithGoogle,
  loginWithApple,
  theme,
  t,
  availableMethods = {swissid: getConfigValue('swissIdLanding'), facebook: true, google: true, apple: true},
}) => (
  <SocialLoginView>
    <SocialLoginTitle>{t('or-continue-with')}</SocialLoginTitle>
    <SocialButtonsContainer>
      {availableMethods.swissid && (
        <SocialButton
          title={t('buttons.swiss-id')}
          icon="icon-SwissID.svg"
          id={swissIdLogin}
          {...theme.social?.swiss}
          onClick={loginWithSwissID}
        />
      )}
      {availableMethods.google && (
        <SocialButton
          title={t('buttons.google')}
          icon="icon-google.svg"
          id={googleLogin}
          {...theme.social?.google}
          onClick={loginWithGoogle}
        />
      )}
      {availableMethods.apple && (
        <SocialButton
          title={t('buttons.apple')}
          icon="icon-apple.svg"
          id={appleLogin}
          {...theme.social?.apple}
          onClick={loginWithApple}
        />
      )}
      {availableMethods.facebook && (
        <SocialButton
          title={t('buttons.facebook')}
          icon="icon-facebook.svg"
          id={facebookLogin}
          {...theme.social?.facebook}
          onClick={loginWithFacebook}
        />
      )}
    </SocialButtonsContainer>
  </SocialLoginView>
)

export default CircularSocialLogin
